import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LoaderService} from '../shared/services/loader/loader.service';
import {environment} from '../../environments/environment';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    public loaderService: LoaderService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (!request.url.includes(`${environment.URL_BACKEND}/usuario/foto-usuario`)
    ) {
      // this.loaderService.show();
      const usuario = JSON.parse(window.localStorage.getItem('usuario'));
      if (usuario) {
        request = request.clone({
          setHeaders: {
            Authorization: 'Basic ' + btoa(
              `${usuario?.username}:${usuario?.password}`
            )
          }
        });
      }

      return next.handle(request).pipe(
      );
    } else {
      return next.handle(request);
    }
  }
}
